/** @format */

/* eslint @typescript-eslint/prefer-nullish-coalescing: "warn" -- Legacy code: do not use as an example. */
import { ImageLoader } from 'next/legacy/image';

export const contentfulLoader: ImageLoader = ({ src, quality, width }) => {
    const url = new URL(src);
    url.searchParams.set('fm', 'webp');
    url.searchParams.set('w', width?.toString());
    url.searchParams.set('q', quality?.toString() || '70');
    return url.href;
};
